module.exports = __webpack_public_path__ + "static/drop-fed73a601d11177a0e6b652dd73757a4.png";